document.addEventListener('DOMContentLoaded', () => {
  const addToCartButton = document.getElementById('AddToCart');
  const stickyAddToCart = document.querySelector('product-add-to-cart-sticky');
  if (!addToCartButton || !stickyAddToCart) {
    console.warn('Required elements not found');
    return;
  }
  stickyAddToCart.style.display = 'none';
  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];
    
    if (entry.isIntersecting) {
      stickyAddToCart.style.display = 'none';
    } else {
      stickyAddToCart.style.display = 'block';
    }
  }, {
    threshold: 0,
    rootMargin: '0px'
  });
  observer.observe(addToCartButton);
  window.addEventListener('beforeunload', () => {
    observer.disconnect();
  });
});